export default __webpack_public_path__ + "static/media/lazadahome.b19a598e.svg";